import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EmptyStateComponent, TileComponent } from '@tecalisdev/infinity';
import { IProcessDetailResponse } from '../../../../../processes/models/processes.models';
import { OperationFormChecksCompareInfoComponent } from '../../../../../shared/components/operations/form/operation-form-checks-compare-info/operation-form-checks-compare-info.component';
import { IOperationDetailResponse } from '../../../../models/operations.models';
import {
	asFormOperationDetail,
	buildFormOperationChecksDetail,
	resolveFormOperationOcrPayload,
} from '../../../../utils/form-operation-detail-contract.util';
import {
	listFormMatchCompareFields,
	shouldSuppressOcrKoInAntifraud,
} from '../../../../utils/form-operation-match-compare.util';
import { OperationDetailTabsChecksOcrComponent } from '../operation-detail-tabs-checks-ocr/operation-detail-tabs-checks-ocr.component';

/**
 * Comprobaciones de operación FORM (Figma `9257-173698`).
 * Reutiliza tiles OCR cuando `data.checks.ocr` viene del admin_back y añade cotejo FORM.
 */
@Component({
	selector: 'app-operation-detail-tabs-checks-form',
	imports: [
		TranslatePipe,
		EmptyStateComponent,
		TileComponent,
		OperationDetailTabsChecksOcrComponent,
		OperationFormChecksCompareInfoComponent,
	],
	templateUrl: './operation-detail-tabs-checks-form.component.html',
	styleUrl: './operation-detail-tabs-checks-form.component.scss',
})
export class OperationDetailTabsChecksFormComponent implements OnChanges {
	@Input() detail: IOperationDetailResponse;

	public ocrChecksDetail: IOperationDetailResponse | null = null;
	public formChecksDetail: IProcessDetailResponse | null = null;
	public hasOcrChecksContent = false;
	public hasFormMatchCompare = false;
	public suppressKoOcrInAntifraud = false;

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['detail']) {
			return;
		}
		this.recomputeFromDetail();
	}

	private recomputeFromDetail(): void {
		const form = asFormOperationDetail(this.detail?.data);
		const ocr = resolveFormOperationOcrPayload(form);
		this.hasOcrChecksContent = ocr !== null;
		this.ocrChecksDetail =
			this.hasOcrChecksContent && this.detail && ocr
				? ({
						...this.detail,
						data: ocr as unknown as IOperationDetailResponse['data'],
					} as IOperationDetailResponse)
				: null;

		this.hasFormMatchCompare = listFormMatchCompareFields(form).length > 0;
		this.formChecksDetail = this.hasFormMatchCompare ? buildFormOperationChecksDetail(this.detail) : null;
		this.suppressKoOcrInAntifraud = shouldSuppressOcrKoInAntifraud(ocr, form);
	}
}
